import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=481c092c&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"
import style1 from "./Help.vue?vue&type=style&index=1&id=481c092c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c092c",
  null
  
)

export default component.exports